import React, { useState, useEffect } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
  TextInput,
  ScrollView,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import RNPickerSelect from "react-native-picker-select";
import { pickImage } from "../../action/authImage";
import { apiservice } from "../../service/service";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { useIsFocused } from "@react-navigation/native";
import { getevent } from "../../action/actionGet";
const AddressThailand = require("../../component/address.json");
const { width, height } = Dimensions.get("window");

export default function createuser({ navigation }) {
  const token = useRecoilValue(tokenState);
  const [packages, setPackage] = useState("");
  const [bibz, setbib] = useState("");
  const [isPackagePremium, setIsPackagePremium] = useState(null);
  const [isBibPremium, setIsBibPremium] = useState(null);
  const focus = useIsFocused();
  const [full, setfull] = useState({
    size: "ไม่รับ",
    ShippingAddress: "",
    subDistrict: "",
    district: "",
    province: "",
    postcode: "",
  });

  const placeholder = {
    label: "Role",
    value: null,
    color: "#777777",
  };

  const placeholderType = {
    label: "Type",
    value: null,
    color: "#777777",
  };

  const items = [
    { label: "member", value: "USER" },
    { label: "VIP", value: "VIP" },
  ]

  const itemsType = [
    { label: "Username-password", value: "EMAIL" },
    { label: "Google", value: "GOOGLE" },
    { label: "Line", value: "LINE" },
    { label: "Facebook", value: "FACEBOOK" },
    { label: "Apple", value: "APPLE" },
  ]

  const [body, setBody] = useState({
    Type: "EMAIL",
    role: "USER",
    username: "",
    image_Profile: null,
    email: "",
    full_address: {},
    name: "",
    tel: "",
    password: "",
  });

  const [body1, setBody1] = useState({
    gold: "",
    cal: "",
  });

  const [open1, setOpen] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [allMatchedAddresses, setAllMatchedAddresses] = useState([]);
  const [event, setevent] = useState([]);
  const [event1, setevent1] = useState([]);
  const [event2, setevent2] = useState(null);
  const [selectTag, setSelectTag] = useState(null);

  async function allEvent() {
    const get = await getevent(token);
    if (get.status == 200) {
      setevent(get?.data?.data);
      setevent1(
        get?.data?.data?.map((item) => {
          return { label: item.titel, value: (item?.id).toString() };
        })
      );
    }
  }

  useEffect(() => {
    allEvent();
  }, [token, focus]);

  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <ScrollView>
        <View style={styles.back}>
          <Admin />
          <View style={styles.viewfree}>
            <Text style={styles.textfree}>
              USER{" "}
              <Text style={styles.textfree1}>
                / <Text style={styles.textfree1}>ADD USER</Text>
              </Text>
            </Text>
            <TouchableOpacity
              onPress={async () => {
                let dataEV = event2;
                const response = await apiservice({
                  path: "/authen/register",
                  method: "post",
                  body: {
                    ...body,
                    username: body.username.length > 0
                      ? body.username
                      : "user" + Math.floor(Math.random() * 1000000),
                    password:
                      body.Type == "EMAIL" && body.password.length > 0
                        ? body.password
                        : "Pass" + Math.floor(Math.random() * 1000000),
                    full_address: full,
                    link: body.role == "VIP",
                  },
                  token: token?.accessToken,
                });
                if (response.status == 200 && !dataEV.id) {
                  alert("Create user successfully");
                  navigation.goBack();
                  return;
                }

                if (dataEV.id && bibz) {
                  const check = await apiservice({
                    path: "/event/postbib_event",
                    method: "post",
                    body: {
                      event_id: dataEV.id,
                      bib: bibz.toString(),
                      number: parseInt(bibz),
                      char: "V",
                    },
                    token: token.accessToken,
                  });

                  if (check.status == 200) {
                    // compute total_distance safely and omit if not found
                    const matchedDistance = dataEV?.distance?.find(
                      (e) => String(e?.distance) === String(packages)
                    );
                    const computedTotalDistance = matchedDistance && matchedDistance.distance != null
                      ? Number(matchedDistance.distance) * 1000
                      : null;

                    const joinBody = {
                      event_id: dataEV.id,
                      packageId: packages,
                      img_event: dataEV.img_title,
                      event_name: dataEV.titel,
                      Type: "EVENT",
                      uid: response?.data?.id,
                      last_distance: 0,
                      reward_Info: dataEV.reward,
                      fullAddress: full,
                      tracking: "",
                      bib: "V" + bibz,
                      biburl: isBibPremium == "Bib Vip" ? event2?.distance?.find(e => e.id == packages)?.img_pre : event2?.distance?.find(e => e.id == packages)?.img_basic,
                      pay_status: isPackagePremium == "Vip" ? event2?.distance?.find(e => e.id == packages)?.price : event2?.distance?.find(e => e.id == packages)?.premiumPrice,
                      VIP_Status: body.role == "VIP" ? true : isBibPremium == "Bib Vip" ? true : false,
                      isBIBVIP: isBibPremium == "Bib Vip" ? true : false,
                      isPremium: isPackagePremium == "Vip" ? true : false,
                      tag: selectTag,
                      total_distance: event2?.distance?.find(e => e.id == packages)?.distance * 1000 || null,
                    };

                    const resposne = await apiservice({
                      path: "/event/postjoinEvent",
                      method: "post",
                      body: joinBody,
                      token: token.accessToken,
                    });

                    if (resposne.status == 200) {
                      navigation.goBack();

                      return;
                    }
                  }
                }

                navigation.goBack();
              }}
              style={styles.touchadd}
            >
              <Text style={styles.textadd}>CREATE</Text>
            </TouchableOpacity>
          </View>

          <View style={{ flexDirection: "row", marginTop: 16 }}>
            <View >
              {body.Type === "EMAIL" && (
                <View style={styles.viewfor}>
                  <Text style={styles.textname1}>USER</Text>
                  <TextInput
                    placeholder="กรอกuser"
                    style={styles.inputuser}
                    onChangeText={(text) => {
                      setBody({ ...body, username: text });
                    }}
                  />
                  <Text style={styles.textname1}>PASSWORD</Text>
                  <TextInput
                    placeholder="กรอกรหัสผ่าน"
                    style={styles.inputuser}
                    onChangeText={(text) => {
                      setBody({ ...body, password: text });
                    }}
                  />
                </View>
              )}

              <View style={[styles.viewfor, { marginTop: 10 }]}>
                <View style={{ flexDirection: "row" }}>
                  <View style={{ flexDirection: "row" }}>
                    <TouchableOpacity
                      onPress={async () => {
                        const response = await pickImage();
                        setBody({
                          ...body,
                          image_Profile: response,
                        });
                      }}
                      style={{ justifyContent: "center", marginRight: 20 }}
                    >
                      {body.image_Profile == null ? (
                        <View>
                          <Image
                            style={{
                              width: 80,
                              height: 80,
                              opacity: 0.5,
                              justifyContent: "center",
                              marginTop: -20,
                            }}
                            source={require("../../image/img.png")}
                          />
                          <Image
                            style={{
                              width: 30,
                              height: 30,
                              opacity: 0.8,
                              position: "absolute",
                              alignSelf: "center",
                            }}
                            source={require("../../image/Group222.png")}
                          />
                        </View>
                      ) : (
                        <Image
                          style={{ width: 80, height: 80, alignSelf: "center" }}
                          source={{
                            uri: body.image_Profile,
                          }}
                        />
                      )}
                    </TouchableOpacity>
                    <View>
                      <TextInput
                        placeholder="กรอกชื่อ"
                        style={styles.inputadd}
                        value={body?.text}
                        onChangeText={(text) => {
                          setBody((val) => ({ ...val, name: text }));
                        }}
                      />
                    </View>
                  </View>
                  <View>
                    <View style={{ flexDirection: "row", marginLeft: 20 }}>
                      <Text style={styles.textname}>Email :</Text>
                      <TextInput
                        placeholder="กรอกอีเมล"
                        style={[styles.inputadd, { marginLeft: 25 }]}
                        onChangeText={(text) => {
                          setBody({ ...body, email: text });
                        }}
                      />
                    </View>
                    <View style={{ flexDirection: "row", marginLeft: 20 }}>
                      <Text style={styles.textname}>ID Code :</Text>
                      <View style={[styles.inputadd, { justifyContent: "center" }]}>
                        <Text
                          style={{
                            fontSize: 14,
                            color: "#444444",
                            fontFamily: "Prompt-Regular",
                          }}
                        >
                          (เว้นไว้เพื่อสุ่มตัวเลข)
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>
                <View style={{ flexDirection: "row" }}>
                  <Image
                    style={{
                      width: 28,
                      height: 32,
                      alignSelf: "center",
                      marginRight: 5,
                    }}
                    source={require("../../image/Icon awesome-running.png")}
                  />
                  <TextInput
                    style={styles.inputimni}
                    placeholder="กรอกตัวเลข"
                    onChangeText={(text) => {
                      setBody1({ ...body1, cal: text });
                    }}
                  />
                  <Image
                    style={{
                      width: 25,
                      height: 25,
                      alignSelf: "center",
                      marginHorizontal: 5,
                    }}
                    source={require("../../image/coin.png")}
                  />
                  <TextInput
                    style={styles.inputimni}
                    placeholder="กรอกตัวเลข"
                    onChangeText={(text) => {
                      setBody1({ ...body1, gold: text });
                    }}
                  />
                  <Text style={[styles.textname, { marginLeft: 10 }]}>
                    สำหรับใช้ช่วงทดสอบ
                  </Text>
                </View>
              </View>
            </View>

            <View style={[styles.viewfree, { marginLeft: 12 }]}>
              <View
                style={{ backgroundColor: "#FFF", padding: 10, borderRadius: 10 }}
              >
                <Text style={styles.textname}>Role</Text>
                <RNPickerSelect
                  placeholder={placeholder}
                  onValueChange={(text) => {
                    setBody((val) => ({ ...val, role: text }));
                  }}
                  style={{
                    inputWeb: {
                      width: width * 0.23,
                      height: 30,
                      borderWidth: 1,
                      borderColor: "#ccc",
                      paddingLeft: 10,
                      borderRadius: 5,
                      color: "#777777",
                      fontFamily: "Prompt-Regular",
                      alignSelf: "center",
                    },
                  }}
                  items={items}
                />

                {body.role != 'VIP' && <Text style={[styles.textname, { marginTop: 10 }]}>Type</Text>}
                {body.role != 'VIP' && <RNPickerSelect
                  placeholder={placeholderType}
                  onValueChange={(text) => {
                    setBody((val) => ({ ...val, Type: text }));
                  }}
                  style={{
                    inputWeb: {
                      width: width * 0.23,
                      height: 30,
                      borderWidth: 1,
                      borderColor: "#ccc",
                      paddingLeft: 10,
                      borderRadius: 5,
                      color: "#777777",
                      fontFamily: "Prompt-Regular",
                      alignSelf: "center",
                    },
                  }}
                  items={itemsType}
                />}
              </View>
            </View>
          </View>

          <Text style={styles.textfree2}>SHIPPING ADDRESS</Text>
          <View style={[styles.view, { marginBottom: 30 }]}>
            {(
              <View style={styles.viewmainfor}>
                <Text style={styles.textname}>EVENT RUNNING</Text>
                <RNPickerSelect
                  placeholder={{
                    label: "Event",
                    value: null,
                    color: "#777777",
                  }}
                  onValueChange={(text) => {
                    setevent2(
                      event?.filter((item) => item?.id?.toString() == text)?.[0]
                    );
                  }}
                  style={{
                    inputWeb: styles.inputadd,
                  }}
                  items={event1}
                />
              </View>
            )}
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}> </Text>
              <RNPickerSelect
                placeholder={{
                  label: "Package",
                  value: null,
                  color: "#777777",
                }}
                onValueChange={(text) => {
                  setPackage(text);
                }}
                style={{
                  inputWeb: styles.inputadd,
                }}
                items={
                  event2?.distances?.map((e) => ({
                    ...e,
                    label: "ระยะทาง " + e?.distance + " km.",
                    value: e?.id,
                  })) || []
                }
              />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}> </Text>
              <RNPickerSelect
                placeholder={{
                  label: "Package",
                  value: null,
                  color: "#777777",
                }}
                onValueChange={(text) => {
                  // not celebrity it user for more payment
                  setIsPackagePremium(text);
                }}
                style={{
                  inputWeb: styles.inputadd,
                }}
                items={
                  [
                    {
                      label: "Vip",
                      value: "Vip",
                    },
                    {
                      label: "Normal",
                      value: "Normal",
                    }
                  ]
                }
              />
            </View>

            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>BIB</Text>
              <TextInput
                maxLength={5}
                style={styles.inputadd}
                onChangeText={(text) => {
                  setbib(text);
                }}
              />
            </View>

            <View style={styles.viewmainfor}>
              <Text style={styles.textname}> </Text>
              <RNPickerSelect
                placeholder={{
                  label: "Package",
                  value: null,
                  color: "#777777",
                }}
                onValueChange={(text) => {
                  setIsBibPremium(text);
                }}
                style={{
                  inputWeb: styles.inputadd,
                }}
                items={
                  [
                    {
                      label: "Bib premium",
                      value: "Bib Vip",
                    },
                    {
                      label: "Bib Normal",
                      value: "Bib Normal",
                    }
                  ]
                }
              />
            </View>

            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>เบอร์โทรศัพท์</Text>
              <TextInput
                style={styles.inputadd}
                onChangeText={(text) => {
                  setBody({ ...body, tel: text });
                }}
              />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>ไซส์เสื้อ</Text>
              <TextInput
                style={styles.inputadd}
                onChangeText={(text) => {
                  setfull({ ...full, size: text });
                }}
                defaultValue={full.size}
              />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>ที่อยู่</Text>
              <TextInput
                multiline
                style={styles.inputadd1}
                onChangeText={(text) => {
                  setfull({ ...full, ShippingAddress: text });
                }}
              />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>แขวง (ตำบล)</Text>
              <RNPickerSelect
                placeholder={{
                  label: "",
                  value: "null",
                  color: "#777777",
                }}
                onValueChange={(text) => {
                  setfull({ ...full, subDistrict: text });
                }}
                style={{
                  inputWeb: styles.inputadd,
                }}
                items={open1}
              />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>เขต (อำเภอ)</Text>
              <RNPickerSelect
                placeholder={{ label: "", value: null, color: "#777777" }}
                value={full?.district}
                onValueChange={(text) => {
                  if (!text) return;
                  const filtered = AddressThailand.filter(
                    (a) =>
                      a.amphoe === text &&
                      a.zipcode.toString() === full?.postcode?.toString()
                  );
                  if (filtered.length > 0) {
                    setfull((val) => ({
                      ...val,
                      district: text,
                      province: filtered[0].province,
                    }));
                    setOpen(
                      filtered.map((val) => ({
                        label: val.label,
                        value: val.label,
                      }))
                    );
                  }
                }}
                style={{ inputWeb: styles.inputadd }}
                items={districtOptions}
              />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>จังหวัด</Text>
              <Text style={styles.inputadd}>{full?.province}</Text>
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>รหัสไปรษณีย์</Text>
              <TextInput
                maxLength={5}
                style={styles.inputadd}
                onChangeText={(text) => {
                  setfull({ ...full, postcode: text });
                  if (text.toString().length == 5) {
                    let matchItems = AddressThailand.filter((address) => {
                      return address.zipcode.toString().includes(text);
                    });

                    if (matchItems.length > 50) {
                      matchItems = [];
                    }

                    if (matchItems.length > 0) {
                      setAllMatchedAddresses(matchItems);

                      // Unique districts
                      const uniqueDistricts = [
                        ...new Set(matchItems.map((a) => a.amphoe)),
                      ];
                      setDistrictOptions(
                        uniqueDistricts.map((d) => ({ label: d, value: d }))
                      );

                      const firstDistrict = matchItems[0].amphoe;
                      const filteredSubs = matchItems.filter(
                        (a) => a.amphoe === firstDistrict
                      );

                      setfull((val) => ({
                        ...val,
                        province: matchItems[0].province,
                        district: firstDistrict,
                        postcode: matchItems[0].zipcode,
                      }));
                      setOpen(
                        filteredSubs.map((val) => ({
                          label: val.label,
                          value: val.label,
                        }))
                      );
                    }
                  }
                }}
              />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>สาขา</Text>
              <RNPickerSelect
                placeholder={{
                  label: "สาขา",
                  value: null,
                  color: "#777777",
                }}
                onValueChange={(text) => {
                  setSelectTag(
                    event2.tag?.filter((item) => item?.toString() == text)?.[0]
                  );
                }}
                style={{
                  inputWeb: styles.inputadd,
                }}
                items={event2?.tag?.map((item) => ({ label: item, value: item })) ?? []}
              />
            </View>
          </View>
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.82,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textfree2: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    marginTop: 10,
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#fff",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 24,
    color: "#172B4D",
    alignSelf: "center",
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  textname: {
    fontSize: 18,
    color: "#000000",
    fontFamily: "Prompt-Regular",
  },
  textname1: {
    fontSize: 16,
    color: "#000000",
    fontFamily: "Prompt-Regular",
  },
  inputuser: {
    width: width * 0.23,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginBottom: 10,
  },
  inputadd: {
    width: width * 0.16,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginBottom: 10,
  },
  inputadd1: {
    width: width * 0.16,
    height: 100,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginBottom: 10,
  },
  viewfor: {
    width: width * 0.55,
    height: 150,
    backgroundColor: "#FFF",
    padding: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    borderRadius: 10,
  },
  inputimni: {
    width: width * 0.1,
    height: 30,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  view: {
    width: width * 0.82,
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
    paddingHorizontal: 10,
    paddingVertical: 20,
  },
  viewmainfor: {
    flexDirection: "row",
    width: width * 0.3,
    justifyContent: "space-between",
  },
});
